var BaseRow = require('./base'),
    RowWithPageLinkMixin = require('../pageRow/rowWithPageLinkMixin');


module.exports = BaseRow.extend({

    initialize: function() {

        BaseRow.prototype.initialize.apply( this, arguments );

        // Need to get the page # from the first hit ... could prob do more efficiently when creating in loop ( or setting model driven )
        this.firstChildHit = this.model.getFirstChild();

        this.listenTo( this.firstChildHit, 'change:isCurrentPage', this.toggleIsCurrentPage );

    },

    onRender: function() {

        BaseRow.prototype.onRender.apply( this, arguments );
        this.toggleIsCurrentPage();

    },

    serializeData: function() {

        var baseCxt = BaseRow.prototype.serializeData.call( this );

        return _.extend( baseCxt, {
            pageNumber: this.firstChildHit.get('pageNumber')

        });

    },


    isCurrentPage: function() {
        return this.firstChildHit.get('isCurrentPage'); // could maybe have a getPageNumbers function ...
    },

    getPageId: function() {
        return this.firstChildHit.get('pageId');
    },


    ui: _.extend( {}, BaseRow.prototype.ui, RowWithPageLinkMixin.ui ),

    events:  _.extend( {}, BaseRow.prototype.events, RowWithPageLinkMixin.events ),

    pageLinkClick: RowWithPageLinkMixin.pageLinkClick,

    toggleIsCurrentPage: RowWithPageLinkMixin.toggleIsCurrentPage



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/searchRow/searchRowWithPageLink.js
 ** module id = 633
 ** module chunks = 0
 **/